/* eslint-disable react-hooks/exhaustive-deps */
import { Background, Popup } from "./styles";
import CloseButton from "components/CloseButton/CloseButton";

const UpdateActivityPopup = ({
    updateActivityPopup,
    confirmExitFromDialog = null,
    mustConfirm = false,
    children
}) => {
    //#region Functions
    const getClassName = classList => classList.join(" ");
    //#endregion
    if (!updateActivityPopup.popup.value)
        return null;
    const { classListGroup } = updateActivityPopup;
    function closePopup() {
        if (mustConfirm && confirmExitFromDialog)
            confirmExitFromDialog();
        else updateActivityPopup.popup.hide();
    }
    return (
        <>
            <Background
                className={getClassName(classListGroup.background)}
                onClick={closePopup} />
            <Popup ref={updateActivityPopup.$popup} className={getClassName(classListGroup.popup)}>
                <CloseButton size="30px" onClick={closePopup} />
                {children}
            </Popup>
        </>
    );
}

export default UpdateActivityPopup;